import { createSelector } from 'reselect';

import { DIRECT_ONLY_IS_ACTIVE_DEFAULT } from '../constants';
import { selectRawFilterData } from './general';

function selectDirectOnly(state, filterId) {
    return selectRawFilterData(state, filterId).directOnly;
}

const selectDirectOnlyFilterData = createSelector(
    selectDirectOnly,
    (isActive) => ({ isActive }),
);

function isDirectOnlyFiltered(isActive) {
    return isActive !== DIRECT_ONLY_IS_ACTIVE_DEFAULT;
}

const selectDirectOnlyIsFiltered = createSelector(
    selectDirectOnly,
    isDirectOnlyFiltered,
);

export {
    selectDirectOnlyFilterData,
    selectDirectOnlyIsFiltered,
};
